import { parseDate } from './utils'

const getProductInfo = (item) => {
	const info = {
		product: 'N/A',
		provider: 'N/A',
		quantity: item.quantity,
		sellPrice: item.saleAmount,
	}

	if (item.appointment) {
		info.product = item.appointment.medicalSpecialty.medicalAct
			? `${item.appointment.medicalSpecialty.medicalAct.medicalActCode} - ${item.appointment.medicalSpecialty.medicalAct.ato_medico_descricao}`
			: `Consulta ${item.appointment.medicalSpecialty.name}`
		info.provider = item.appointment.establishment.name
	}

	if (item.medicalActRequisition) {
		info.product = `${item.medicalActRequisition.code} - ${item.medicalActRequisition.description}`
		info.provider = item.medicalActRequisition.establishment.name
	}

	return info
}

export default class Budget {
	static fromJSON(json) {
		if (!json) return null
		return new Budget(json.id, json.creationDate)
			.withSections(json.lines)
			.withTicketObservations(json.ticket)
	}

	constructor(id, date) {
		this.id = id
		this.date = parseDate(date || '')
	}

	withSections(lines) {
		const visited = new Set()
		const sections = lines.reduce(
			(acc, cur) => {
				if (visited.has(cur.id)) {
					return acc
				}

				const line = {
					product: cur.type.description,
					quantity: cur.quantity,
					sellPrice: cur.saleAmount,
				}

				acc.total.sellPrice += line.quantity * line.sellPrice
				visited.add(cur.id)
				if (cur.type.id === 3) {
					// Franquia
					acc.deductibles.push(line)
					return acc
				}

				if ([1, 2, 4, 5].includes(cur.type.id)) {
					// Avenças e serviços
					if (cur.agreementNumber !== null) {
						// Avenças
						const includedItems = lines
							.filter(
								(item) =>
									item.type.id === 7 &&
									item.agreementNumber === cur.agreementNumber
							)
							.map((item) => getProductInfo(item))

						line.includedItems = includedItems

						includedItems.forEach((item) => visited.add(item.id))
					}

					if (cur.type.id === 5) {
						line.product = cur.description
					}

					acc.global.push(line)
					return acc
				}

				if (cur.type.id === 6) {
					// Venda à peça
					const item = getProductInfo(cur)
					if (cur.appointment) {
						acc.appointments.push(item)
					} else {
						acc.requisitions.push(item)
					}
					return acc
				}

				return acc
			},
			{
				global: [],
				requisitions: [],
				appointments: [],
				deductibles: [],
				total: {
					sellPrice: 0,
				},
			}
		)

		this.sections = sections

		return this
	}

	withTicketObservations(ticket) {
		this.ticketObservations = ticket.observations ?? ''

		return this
	}
}
